import { render } from "./NotificationItem.vue?vue&type=template&id=3fc5dab6"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"
script.render = render

export default script